<template>
  <v-list v-if="todolist.length">
    <v-menu
      v-model="showMenu"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
    >
      <v-list dense>
        <v-list-item
          @click="
            completed({
              id: selected.id,
              value: !selected.completed,
            })
          "
        >
          <v-list-item-content>Complete</v-list-item-content>
        </v-list-item>
        <v-list-item
          @click="starred({ id: selected.id, value: !selected.starred })"
        >
          <v-list-item-content>Star</v-list-item-content>
        </v-list-item>
        <v-list-item @click="editHandler(selected.id, selected.text)">
          <v-list-item-content>Edit</v-list-item-content>
        </v-list-item>
        <v-list-item
          @click="deleted({ id: selected.id, value: !selected.deleted })"
        >
          <v-list-item-content>Delete</v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-divider />
    <EditTaskDialog
      :showDialog="editDialog"
      @onDialogClosed="editDialog = false"
      :taskText="selected.text"
      :taskId="selected.id"
      @onEditSaved="edited($event)"
      v-if="selected !== null"
      @onDelete="deleted($event)"
    ></EditTaskDialog>
    <div v-for="todo in todolist" :key="todo.id">
      <Todo
        @contextmenu.native.prevent="show($event, todo)"
        :id="todo.id"
        :completed="todo.completed"
        :editable="editable"
        :starred="todo.starred"
        :text="todo.text"
        @completed="completed"
        @edited="edited"
        @starred="starred"
      ></Todo>
      <v-divider />
    </div>
    <v-snackbar v-model="editedSnackbar" :timeout="3000">
      <span>Task successfully edited!</span>
      <v-btn color="error" text @click="editedSnackbar = false"> Close </v-btn>
    </v-snackbar>
    <v-snackbar v-model="completedSnackbar" :timeout="4000">
      <span>Task completed!</span>
      <v-btn color="error" text @click="undoCompleted"> Undo </v-btn>
    </v-snackbar>
  </v-list>
  <div v-else-if="searchQuery !== ''">
    <v-divider />
    <v-row>
      <v-col>
        <p class="text-center body-1 mt-4">
          No tasks found that contain "{{ searchQuery }}"
        </p>
      </v-col>
    </v-row>
    <v-divider />
  </div>
  <div v-else>
    <v-divider />

    <v-row>
      <v-col>
        <p class="body-1 text-center mt-5 mb-5">
          {{ todoType }} todos will show up here!
        </p>
        <!--suppress HtmlUnknownTarget -->
        <v-img
          :src="emptyListImage"
          alt="Empty todo list!"
          width="200px"
          class="mx-auto my-5"
        ></v-img>
      </v-col>
    </v-row>

    <v-divider />
  </div>
</template>

<script>
import Todo from '@/components/Todo'
import EditTaskDialog from '@/components/editTaskDialog'

export default {
  name: 'TodoList',
  components: {
    EditTaskDialog,
    Todo,
  },
  props: {
    todos: {
      default: [],
    },
    editable: {
      type: Boolean,
      default: true,
    },
    todoType: {
      type: String,
      default: '',
    },
    emptyListImage: {
      type: String,
    },
    searchQuery: {
      type: String,
      default: '',
    },
  },
  computed: {
    todolist() {
      return this.todos.filter((todo) =>
        todo.text.toLowerCase().includes(this.searchQuery.toLowerCase())
      )
    },
  },
  methods: {
    completed({ id, value }) {
      let sound = require('../assets/sounds/task-completed.mp3')
      let audio = new Audio(sound)
      audio.play().then(() => {
        this.completedSnackbar = true
        this.$store.dispatch('editTodo', {
          id,
          key: 'completed',
          value: value,
        })
        this.undo.id = id
        this.undo.completed = !value
      })
    },
    starred({ id, value }) {
      if (value) {
        // only play sound if task is being starred
        let sound = require('../assets/sounds/task-starred.mp3')
        let audio = new Audio(sound)
        audio.play()
      }
      this.$store.dispatch('editTodo', {
        id,
        key: 'starred',
        value: value,
      })
    },
    edited({ id, value }) {
      this.editDialog = false
      this.editedSnackbar = true
      this.$store.dispatch('editTodo', { id, key: 'text', value: value })
    },
    deleted({ id, value }) {
      this.editDialog = false
      this.$store.dispatch('editTodo', { id, key: 'deleted', value })
    },
    undoCompleted() {
      this.completedSnackbar = false
      let id = this.undo.id
      let completed = this.undo.completed
      this.$store
        .dispatch('editTodo', {
          id,
          key: 'completed',
          value: completed,
        })
        .then(() => {
          this.undo = {
            id: null,
            completed: null,
          }
        })
    },
    show(event, todo) {
      this.selected = todo
      this.showMenu = false
      this.x = event.clientX
      this.y = event.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    editHandler(id, text) {
      this.editDialog = true
      this.newText = text
    },
  },
  data: () => ({
    editDialog: false,
    editedSnackbar: false,
    completedSnackbar: false,
    undo: {
      id: null,
      completed: null,
    },
    showMenu: false,
    x: 0,
    y: 0,
    selected: null,
    newText: '',
  }),
}
</script>

<style></style>
